export default "__VITE_ASSET__DFthEJJz__"